module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Owner address":"Inhaberadresse","No address available":"Keine Adresse vorhanden","Chain of stores":"Filialkette","Pick which stocks each get a business card on the map.":"Wähle aus, welche Lager jeweils eine Visitenkarte auf der Karte erhalten."}}')
  delete Component.options._Ctor
}
